var render = function render(){var _vm=this,_c=_vm._self._c;return _c('WsStateDropdownCheckboxLayers001',{staticClass:"w-full",attrs:{"placeholder":_vm.systemClass.placeholder,"menu":_vm._systemClassMenu,"outline":""},model:{value:(_vm.systemClass.state),callback:function ($$v) {_vm.$set(_vm.systemClass, "state", $$v)},expression:"systemClass.state"}})
}
var staticRenderFns = []

export { render, staticRenderFns }